
import { db, auth } from "../firebase/config";
import {
  collection,
  getDocs,
  addDoc,

} from "firebase/firestore";

//get references of collections named 'appointments'
const submissionsCollectionRef = collection(db, "retakeSubmissions");

export const createRetakeSubmission = async (studentName, department, subject, courseNum, email, tokens, date, time) => {
  try {
    await addDoc(submissionsCollectionRef, {
      department: department,
      subject: subject,
      courseNum: courseNum,      
      studentName: studentName,
      email: email,
      tokens: tokens,
      date: date,
      time: time,
      

    });
    console.log("Doc was added");
  } catch (error) {
    console.error("Doc could not be added", error);
  }
};


export const readRetakeSubmissions = async () => {
  const data = await getDocs(submissionsCollectionRef);
  const submissions = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  let list = [];

  await Promise.all(
    submissions.map(async (submission) => {
      list.push({
        department: submission.department,
        subject: submission.subject,
        courseNum: submission.courseNum,
        studentName: submission.studentName,
        email: submission.studentEmail,
        date: submission.date,
        time: submission.time,
        id: submission.id

      });
    }),
  );
  return list;
};

